module.exports = "/ui/main/images/calendar_icon_gray_b_form.webp?2255874da54a7bdd4fd998319282dad3";